/* Dark homepage — shared horizontal rail controls */
(function () {
  function initRail(root) {
    var rail = root.querySelector('[data-dh-rail]');
    var prev = root.querySelector('[data-dh-rail-prev]');
    var next = root.querySelector('[data-dh-rail-next]');
    if (!rail) return;

    function step() {
      var first = rail.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) || 16;
      var w = first ? first.getBoundingClientRect().width : rail.clientWidth * 0.8;
      return (w + gap) * Math.max(1, Math.floor(rail.clientWidth / (w + gap)));
    }
    function update() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    initAutoscroll(root, rail);
  }

  // Optional mobile-only auto-scroll. Advances one card per interval and loops.
  function initAutoscroll(root, rail) {
    if (root.getAttribute('data-dh-autoscroll') !== 'true') return;
    var delay = parseInt(root.getAttribute('data-dh-autoscroll-speed'), 10) || 3000;
    var mq = window.matchMedia('(max-width: 749px)');
    var timer = null;

    function cardStep() {
      var first = rail.querySelector(':scope > *');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) || 12;
      return first ? first.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function advance() {
      if (document.hidden) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (rail.scrollLeft >= max) rail.scrollTo({ left: 0, behavior: 'smooth' });
      else rail.scrollBy({ left: cardStep(), behavior: 'smooth' });
    }
    function start() { if (!timer && mq.matches) timer = setInterval(advance, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // Pause while the user is interacting, resume afterwards.
    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) {
      rail.addEventListener(ev, stop, { passive: true });
    });
    ['touchend', 'mouseleave'].forEach(function (ev) {
      rail.addEventListener(ev, start, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    function onChange() { stop(); start(); }
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-dh-rail-root]').forEach(initRail);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
